module.exports = __webpack_public_path__ + "img/banner_localinfo.0483ebfd.png";